import "./AboutUs.css";
import HeroSection from "../../components/HeroSection/HeroSection";
import AboutUsImage from "../../assets/images/AboutUs3.jpg";
import { useRef } from "react";

import officeImage2 from "../../assets/images/office-2.jpg";
import officeImage3 from "../../assets/images/office3.jpeg";

import targetImage from "../../assets/images/target.png";
import sharedVisionImage from "../../assets/images/shared-vision (1).png";
import badgeImage from "../../assets/images/badge (3).png";
import FloatImg1 from "../../assets/images/floatImg1.jpeg";
import Carpenter from "../../assets/images/carpenter.jpeg";
import { FaLinkedin } from "react-icons/fa";
import VolunteerForm from "../../components/VolunterrForm/VolunteerForm";
import crossIndustryPic from "../../assets/images/cross-industry-pic.avif";
import Leadership from "../../assets/images/Leadership.webp";
import ItSolutions from "../../assets/images/ItSolutions.jpg";

import experienceTwo from "../../assets/images/experience-2.jpg";
import YouTube from "react-youtube";

import workinghand from "../../assets/images/workinghand.jpg";

import { HiOutlineUsers } from "react-icons/hi2";
import { SlGraduation } from "react-icons/sl";
import { HiOutlineTrophy } from "react-icons/hi2";
import { MdCastForEducation } from "react-icons/md";

import { BsPeople } from "react-icons/bs";
import { SiHyperskill } from "react-icons/si";
import { TbUserSearch } from "react-icons/tb";
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import ceoImage from "../../assets/images/ceo.jpeg";

import { motion } from "framer-motion";
import Footer from "../../components/Footer";
import CeoVideoImage from "../../assets/images/CeovideoImage.png";

import { useState } from "react";

import { useEffect } from "react";
const About = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowVideo(true);
    }, 3000); // Show video after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  const [showVolunteerForm, setShowVolunteerForm] = useState(false);

  const handleCloseForm = () => {
    setShowVolunteerForm(false);
  };
  const experienceSectionRef = useRef(null);

  const scrollToExperience = () => {
    experienceSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const exploreBtnRef = useRef(null);
  useEffect(() => {
    // Show video after 3 seconds (adjust timing as needed)
    const videoTimer = setTimeout(() => {
      setShowVideo(true);
    }, 3000); // 3000ms = 3 seconds

    return () => clearTimeout(videoTimer);
  }, []);
  useEffect(() => {
    const button = exploreBtnRef.current;
    if (button) {
      button.addEventListener("click", scrollToExperience);
    }

    return () => {
      if (button) {
        button.removeEventListener("click", scrollToExperience);
      }
    };
  }, []);

  return (
    <div className="about-container">
      <div ref={exploreBtnRef}>
        <HeroSection
          cName="about-hero"
          title="About Chauwk"
          text="Empowering Communities, Building Futures"
          heroImg={AboutUsImage}
          buttonText="Explore More"
          btnClass="show"
          url="#"
        />
      </div>
      <div className="about-us-section">
        <div className="about-us-section-heading">ABOUT US</div>
        <div className="about-us-section-para">
          Chauwk is the modern digital evolution of the traditional town
          square—where workforce engagement, learning, communication, and growth
          come together through intelligent technology. Leveraging AI-powered
          multilingual voice agents, gamified engagement, and digital workforce
          solutions, Chauwk helps enterprises strengthen communication, enable
          continuous upskilling, improve customer and workforce interactions,
          and drive meaningful productivity and loyalty across their blue and
          grey-collared workforce.
        </div>
        <div className="figures-container">
          <figure className="snip1477">
            <img src={crossIndustryPic} alt="Cross Industry" />

            <div className="title">
              <div>
                <h2 className="user-left">User</h2>
                <h4>Understanding</h4>
              </div>
            </div>
            <figcaption>
              <p>
                We understand what your blue-grey collared workforce needs to be
                productive and loyal to your organization.
              </p>
            </figcaption>
            <a href="#"></a>
          </figure>
          <figure className="snip1477 hover">
            <img src={Leadership} alt="Cross Industry" />

            <div className="title">
              <div>
                <h2>Industry</h2>
                <h4>Expertise</h4>
              </div>
            </div>
            <figcaption>
              <p>
                We know your challenges in hiring, engaging and getting the
                right output from the Blue-grey collared workers.
              </p>
            </figcaption>
            <a href="#"></a>
          </figure>
          <figure className="snip1477">
            <img src={ItSolutions} alt="Cross Industry" />

            <div className="title">
              <div>
                <h2 style={{ transform: "translateX(-16px)" }}>Best-It</h2>
                <h4>Solutions</h4>
              </div>
            </div>
            <figcaption>
              <p>
                AI powered solutions to create an optimal working environment to
                empower the manager and the employee to deliver growth
              </p>
            </figcaption>
            <a href="#"></a>
          </figure>
        </div>
        <section className="wrapper-aboutUs">
          <div className="Mission-heading">
            <h1 style={{ textAlign: "center" }}>OUR MISSION & VISION VALUES</h1>
            <h2 style={{ textAlign: "center" }}>
              Empowering Through Opportunity
            </h2>

            <div className="circle-container">
              {["home-dots-container", "home-dots-container-2"].map(
                (cls, idx) => (
                  <div key={idx} className={cls}>
                    {[...Array(50)].map((_, i) => (
                      <div key={i} className="dot"></div>
                    ))}
                  </div>
                )
              )}
              <div className="outer-circle">
                <img src={officeImage2} alt="Outer" />
              </div>
              <div className="inner-circle">
                <img src={officeImage3} alt="Inner" />
              </div>
            </div>

            <div className="mission-points-wrapper">
              {[
                {
                  img: targetImage,
                  title: "Mission",
                  desc: "Chauwk is an intelligent AI-powered enterprise and <br/>workforce engagement platform focused on <br />transforming business communication, customer <br />interactions, and frontline workforce productivity <br/>through innovative digital and offline solutions. ",
                },
                {
                  img: sharedVisionImage,
                  title: "Vision",
                  desc: "To become a leading global AI-powered enterprise solutions and <br/>frontline workforce engagement platform, enabling businesses <br/>through intelligent digital technologies, while continuing to create <br />meaningful social and economic impact across the blue and grey- <br/>collared workforce ecosystem.",
                },
                {
                  img: badgeImage,
                  title: "Values",
                  desc: "We prioritize long-term relationships with clients,partners,<br/> and employees through mutual growth.",
                },
              ].map((point, idx) => (
                <div
                  key={idx}
                  className="point"
                >
                  <div className="text-wrapper">
                    <img
                      src={point.img}
                      alt="icon"
                      style={{
                        width: "120px",
                        height: "120px",
                        marginRight: "12px",
                        marginTop: "-20px",
                        objectFit: "contain",
                        zIndex: 5,
                        position: "relative",
                      }}
                    />
                    <h4>{point.title}</h4>
                  </div>
                  <p
                    style={{
                      fontSize: "20px",
                      color: "#1a1a1bff",
                    }}
                    dangerouslySetInnerHTML={{ __html: point.desc }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className="experience-section">
          <div className="experience-left-box">
            <h3 className="experience-heading">
              HANDS-ON EXPERIENCE MAKES US CONFIDENT
            </h3>
            <h2 className="experience-subheading">INNOVATION EXPERIENCE</h2>

            <p>
              At Chauwk, our team bring years of diverse experience and industry
              knowledge, creating innovative solutions that empower workers and
              address workforce needs across various sectors.
            </p>
            <p>
              With a strong commitment from leadership, they not only manage
              operations efficiently but also mentor and also guide individuals.
            </p>
            <div className="transformation-text">
              <h3>TRANSFORMATION</h3>
              <p>
                We make organization development engaging and accessible through
                gamified experiences.
              </p>
            </div>
          </div>
        </div>

        {/* <div className="experience-2">
          <img src={experienceTwo} alt="experienceTwo" />
        </div> */}
        {/* REPLACED IMAGE WITH YOUTUBE VIDEO */}
        {/* Image that shows first, then replaced by video after delay */}
        <div className="experience-2">
          {!showVideo ? (
            <img src={experienceTwo} alt="experienceTwo" />
          ) : (
            <YouTube
              videoId="pLw4-TtxS1k"
              opts={{
                height: "500",
                width: "860",
                playerVars: {
                  autoplay: 1, // Auto-play when video appears
                  modestbranding: 1,
                  rel: 0,
                },
              }}
              className="youtube-video-embed"
            />
          )}
        </div>
        <div className="experience-2-content" ref={experienceSectionRef}>
          <div className="working-hand-container">
            <img
              src={workinghand}
              alt="Working Hand"
              className="working-hand-image"
            />
            <div className="overlay"></div>

            <div className="text-experience">WE ARE HERE TO HELP YOU</div>
            <div className="text">
              {" "}
              <p>
                Get an Amazing <br />
                <span>Experience With Us</span>
              </p>{" "}
            </div>
            <div className="text-para">
              <p>
                We are dedicated to providing you with an amazing experience
                every step of the way. Let us guide you to an extraordinary
                journey of discovery and growth
              </p>
            </div>
            <div className="experience-icons">
              <div className="icon">
                <HiOutlineUsers />
                <p>Human Centric</p>
              </div>
              <div className="icon">
                <SlGraduation />
                <p>Enterprise Grade</p>
              </div>
              <div className="icon">
                <HiOutlineTrophy />
                <p>Scalable AI Solutions</p>
              </div>
              <div className="icon">
                <MdCastForEducation />
                <p>Global Persepective</p>
              </div>
            </div>
          </div>
        </div>
        <div className="founder-compact-section">
          <div className="founder-compact-container">
            <div className="founder-left-col">
              <div className="founder-img-wrapper">
                <img src={ceoImage} alt="CEO" className="founder-main-img" />
                <div className="founder-mini-badge">CEO & Founder</div>
              </div>
            </div>

            <div className="founder-right-col">
              <h4 className="founder-overhead">CHAUWK’S FOUNDER</h4>
              <h2 className="founder-main-name">
                Abhishek Kumar Gupta{" "}
                <a
                  href="https://www.linkedin.com/in/varenyam/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="founder-li-icon"
                >
                  <FaLinkedin />
                </a>
              </h2>

              <div className="founder-content-text">
                <p className="founder-primary-bio">
                  A passionate entrepreneur dedicated to shaping the future of the industry.
                  With a clear vision and unwavering commitment, he leads our team toward excellence and impact.
                </p>

                <p className="founder-secondary-exp">
                  With a strong background in holistic business planning and execution,
                  he has successfully transformed companies into industry leaders.
                </p>

                <ul className="founder-perks">
                  <li>✅ 22+ years of leadership in multiple industries.</li>
                  <li>✅ Scaled companies to market success.</li>
                  <li>✅ Expert in innovation & team building.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="image-section">
          <div className="image-1">
            <img src={FloatImg1} alt="Picture 1" />
          </div>
          <div className="image-2">
            <img src={Carpenter} alt="Picture 2" />
          </div>
          <div className="small-circle-home small-circle-1"></div>
          <div className="small-circle-home small-circle-2"></div>
          <div className="small-circle-home small-circle-3"></div>
          <div className="small-circle-home small-circle-4"></div>
          <div className="small-circle-home small-circle-5"></div>
          <div className="small-circle-home small-circle-6"></div>
          <div className="small-circle-home small-circle-7"></div>
          <div className="small-circle-home small-circle-8"></div>
        </div>
        <div className="info-section padding">
          <div className="info-section-box">
            <div className="info-item">
              <p
                className="info-description"
                style={{ color: "#4a4a4a" }}
                ref={(el) => el && el.style.setProperty("color", "#4a4a4a", "important")}
              >
                Welcome to Chauwk, we aim to uplift and support those who build
                our communities through hard work and dedication.
              </p>
            </div>
            <div className="info-item">
              <h3 className="info-heading">
                You Can Be a Part of Changes in Chauwk
              </h3>
              <p className="info-description-2">
                Join us in our mission to improve the lives of blue-collar
                workers everywhere and support, ensuring dignity and respect for
                all.
              </p>
              <button
                className="click-button"
                onClick={() => setShowVolunteerForm(true)}
              >
                GET INVOLVED
              </button>

              <div></div>
            </div>
          </div>
        </div>
        <div className="working-process">
          <div className="working-process-content">
            <p className="working-subtitle">THE CHAUWK WAY</p>
            <p className="working-title">
              Our Holistic Product Development Process
            </p>

            <div className="circles-container">
              <div className="about-us-circle-1">
                <BsPeople className="icon" />
              </div>
              <div className="text-data-box">
                <h2 className="heading">Customer Discovery </h2>
                <p className="paragraph">Problem-Solution Fit</p>
              </div>
              <div className="tiny-circle">1</div>
              <div className="diagonal-line "></div>
              <div className="about-us-circle-2">
                {" "}
                <SiHyperskill className="icon" />
              </div>{" "}
              <div className="tiny-circle-2">2</div>
              <div className="text-data-box-2">
                <h2 className="heading">Solution Design </h2>
                <p className="paragraph">Solution-Market Fit</p>
              </div>
              <div className="diagonal-line-2 "></div>
              <div className="about-us-circle-3">
                <TbUserSearch className="icon" />
              </div>
              <div className="text-data-box-3">
                <h2 className="heading">Product Growth & Maturity </h2>
                <p className="paragraph">Scale & Optimize</p>
              </div>
              <div className="tiny-circle-3">3</div>
              <div className="diagonal-line-3"></div>
              <div className="about-us-circle-4">
                <MdOutlinePublishedWithChanges className="icon" />
              </div>
              <div className="tiny-circle-4">4</div>
              <div className="text-data-box-4">
                <h2 className="heading">Product Development & Launch </h2>
                <p className="paragraph">Product-Market Fit</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {showVolunteerForm && <VolunteerForm onClose={handleCloseForm} />}
    </div>
  );
};

export default About;
